import { UpgradeSimulationTypes } from '../../domain/upgrade.simulation';

export interface IUpgradeSimulationRequest {
    UpgradeSimulationType: UpgradeSimulationTypes;
    CurrentPrice: number;
    NewPrice: number;
    DecimalPrecisionCalculation: number;
    DecimalPrecisionResult: number;
    DueDate: Date;
    NewDueDate: Date;
    NowDate: Date;

}

export class UpgradeSimulationRequest implements IUpgradeSimulationRequest {
    UpgradeSimulationType: UpgradeSimulationTypes;
    CurrentPrice: number;
    NewPrice: number;
    DecimalPrecisionCalculation: number;
    DecimalPrecisionResult: number;
    DueDate: Date;
    NewDueDate: Date;
    NowDate: Date;
}
